import {
    IChatBubblesItem,
} from '@vfde-brix/chat-bubbles';

import { renderContainerForWebchatContent } from './renderContainerForWebchatContent';

import { WRAPPER_CHATBUBBLES_NAME } from '../constants';

import mountChatBubbles from '../../../components/chatBubbles';
import cleanUpMarkup from '../../../helper/cleanUpMarkup';
import { WEBCHAT_INVALID_INOUT } from 'Constant';

/**
 * export function which renders chat bubbles
 * @param wrapper
 * @param items
 */
export const renderChatBubbles = (texts: string[], dark: boolean, wrapperContainerId?: string): string => {

    const containerChatContentIdForChatBubbles = renderContainerForWebchatContent(WRAPPER_CHATBUBBLES_NAME, wrapperContainerId);

    let optStyle = {};

    if (dark) {
        optStyle = { optStyle: 'dark' };
    }

    const items: IChatBubblesItem[] = [];
    for (let i = 0; i < texts.length; i++) {

        if ('' === texts[i]) {
            continue;
        }

        let sanitizedHTML = cleanUpMarkup(texts[i]);
        if ('' === sanitizedHTML) {
            sanitizedHTML = WEBCHAT_INVALID_INOUT;
        }
        items.push({
            txtContent: sanitizedHTML,
            ...optStyle,
        });
    }

    mountChatBubbles(
        document.getElementById(containerChatContentIdForChatBubbles),
        items,
    );

    return containerChatContentIdForChatBubbles;
};
